/**
 * Separate set of FormControl from top-level that isn't tied to PDS
 */
import FormControl from 'shared/components/FormControl/FormControl';

import UnwrappedColorInput from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorStyleSections/inputs/ColorInput';
import UnwrappedFileUpload from 'dashboard/components-lib/FileUpload';

export default FormControl;
export const ColorInput = FormControl(UnwrappedColorInput);
export const FileUpload = FormControl(UnwrappedFileUpload);
